import React from 'react';
import { usePermission, useAnyPermission } from '../hooks/useAuth';
import PermissionGuard from './PermissionGuard';

const PermissionButton = ({ 
  children, 
  permission = null,
  permissions = [],
  requireAll = false,
  allowSuperAdmin = false, // Deprecated: no longer used
  className = '',
  onClick,
  disabled = false,
  type = 'button',
  ...props 
}) => {
  return (
    <PermissionGuard
      permission={permission}
      permissions={permissions}
      requireAll={requireAll}
      allowSuperAdmin={false} // Strictly permission-based
      fallback={null}
    >
      <button
        type={type}
        className={className}
        onClick={onClick}
        disabled={disabled}
        {...props}
      >
        {children}
      </button>
    </PermissionGuard>
  );
};

export default PermissionButton; 